import { listingMeublesImageNomMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = (productType: string) => [listingMeublesImageNomMock(productType)];

export const meublesImageNomMock = (productType: string): SlugPage => ({
  ...pageBase({
    title: productType,
    type: 'undefined',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks: blocks(productType),
});
